import React, { useMemo, useState, useEffect } from 'react';
import DefaultLayout from '../../../Components/DefaultLayout';
import { Box, Grid, Alert,Button } from '@mui/material';
import { Typography } from '@mui/joy';
import { useDispatch,useSelector } from 'react-redux';
import { fetchData, postData } from '../../../redux/apiSlice';
import MaterialReactTable from 'material-react-table';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader';
import swal from "sweetalert";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import formatPhoneNumber from "../../../../src/Components/Formats/PhoneNumberValidation";
import AuthUser from '../../../Components/Auth/AuthUser';
import Moment from 'moment';

function AffiliateAbandoned() {
      const dispatch = useDispatch();
       const { user } = AuthUser();
      const [abandonedMembersData, setAbandonedMembersData] = useState([]);
      const [freez, setFreez] = React.useState(false);
      const [rowSelection, setRowSelection] = useState({});
      const [columnVisibility, setColumnVisibility] = React.useState({});
      const tablePreferencesArray = {
      }

      useEffect(() => {
        getAbandoned();
      }, []);

      useEffect(() => {
          if (Object.values(columnVisibility).length > 0) {
            setColumnVisibility(columnVisibility);
          }
      }, [rowSelection]);
      
      useEffect(() => {
        tablePreferences();
      }, []);
      
      useEffect(() => {
        saveTablePreferences();
      }, [columnVisibility])
      
      const tablePreferences = async () => {
        const apiUrl = '/fetchTablePreferences/affiliateAbandonedList';
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
          if (Object.values(res).length == 0) {
            setColumnVisibility(tablePreferencesArray);
          } else {
            setColumnVisibility((JSON.parse(res.preferences)));
          }
        }
      }
      
      const saveTablePreferences = async () => {
        if (Object.values(columnVisibility).length > 0) {
          const apiUrl = '/saveTablePreferences';
          const args = {
            columnArray: columnVisibility,
            userId: user.id,
            tableId: 'affiliateAbandonedList'
          }
          const res = await dispatch(postData({ apiUrl, args })).unwrap();
        }
      }

      const handleFreezStop = () => {
        setFreez(false);
      };
      const handleFreezStart = () => {
        setFreez(true);
      };

      const getAbandoned = async () => {
          handleFreezStart();
          const apiUrl = '/abandonedMember';
          const args = {};
          const res = await dispatch(postData({ apiUrl, args })).unwrap();
          if (res) {
            if(res.success === true) {
              setAbandonedMembersData(res.data);
              handleFreezStop();
            }else{
              swal({
                title: "Failed",
                text: res.message,
                icon: "error",
                button: "Ok",
              })
            }
          }
        }
     const columns = useMemo(
        //column definitions...
        () => [
          
          {
            accessorFn: (data) => `${data.first_name ? data.first_name.trim() +" "+ data.last_name.trim() : ''}`,
            id: 'Name',
            header: 'Name',
            size: 50,
            Cell: ({ renderedCellValue, row }) => (row.original.first_name ? row.original.first_name.trim() +" " + row.original.last_name.trim() : 'N/A'),
          },
          {
            accessorFn: (data) => `${data.email ? data.email.trim() : ''}`,
            id: 'Email',
            header: 'Email',
            size: 50,
            sortingFn: (rowA, rowB) => {
              const emailA = rowA.original.email.toLowerCase();
              const emailB = rowB.original.email.toLowerCase();
              return emailA.localeCompare(emailB);
            },
            Cell: ({ renderedCellValue, row }) => (row.original.email ? row.original.email.trim() : 'N/A'),
          },
          {
            accessorFn: (data) => `${data.phone_number ? data.phone_number : ''}`,
            id: 'PhoneNumber',
            header: 'Phone Number',
            size: 50,
            Cell: ({ renderedCellValue, row }) => (row.original.phone_number  ? formatPhoneNumber(row.original.phone_number) : 'N/A'),
          },
          {
            accessorFn: (data) => `${data.pid ? data.pid : ''}`,
            id: 'PID',
            header: 'PID',
            size: 50,
            Cell: ({ renderedCellValue, row }) => (row.original.pid ? row.original.pid : 'N/A'),
          },
          {
            accessorFn: (data) => `${data.aid ? data.aid.trim() : ''}`,
            id: 'AID',
            header: 'AID',
            size: 50,
            Cell: ({ renderedCellValue, row }) => (row.original.aid ? row.original.aid.trim() : 'N/A'),
          },
          {
            accessorKey: 'Enrollment Date',
            accessorFn: (row) => `${row.created_at ? row.created_at : ''}`,
            header: 'Enrolled Date',
            size: 50,
            Cell: ({ renderedCellValue, row }) => (
              <div>
                {row.original.created_at ? Moment(row.original.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY H:mm') : 'N/A'}
              </div>
            ),
          },
          {
            // accessorFn: (data) => `${data.date_range_filter?data.date_range_filter:''}`,
            id: 'Step',
            header: 'Abandoned At',
            size: 50,
            Cell: ({ renderedCellValue, row }) => (
              <div>
                {
                  row.original.completed != "" ?
                    row.original.completed == 2  &&  row.original.dv_error ? "Digital Verification" :  row.original.completed == 2 ? "ID Verification" : row.original.completed == 3 && row.original.dv_error ? "Payment Details (Manually Authenticated)" : row.original.completed == 3 ? "Payment Details" :
                      row.original.completed == 'YES' ? "Payment Details" : "Payment Details"
                    : row.original.street_address != '' ? "ID Verification" : "Other"
    
                }
              </div>
            ),
          },
    
        ]
    );

    const convertToCSV = (data, csvOptions) => {
      const headers = csvOptions.headers.join(',') + '\n';
    
      const rows = data.map((row) => {
        return Object.values(row).map((value) => {
          // Handle any necessary formatting or escaping of values
          // For simplicity, we assume all values are already properly formatted
          return value;
        }).join(',');
      }).join('\n');
    
      return headers + rows;
    };
    
    const handleExportData = (rows) => {
      const loginUser = JSON.parse(localStorage.getItem('user'));
  
      let exportedData;
      let exportedColumns;
  
        // Export data and columns for columns
        exportedData = rows.map((row) => {
          return {
            name: row.original.first_name && row.original.last_name ?  row.original.first_name + " " + row.original.last_name : "N/A",
            email: row.original.email || "N/A",
            phone_number: row.original.phone_number || "N/A",
            PID: row.original.pid || "N/A",
            AID: row.original.aid || "N/A",
            enrollment_date: row.original.created_at ? Moment(row.original.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY H:mm') : 'N/A',
            Step: row.original.completed != "" ?
            row.original.completed == 2  &&  row.original.dv_error ? "Digital Verification" :  row.original.completed == 2 ? "ID Verification" : row.original.completed == 3 && row.original.dv_error ? "Payment Details (Manually Authenticated)" : row.original.completed == 3 ? "Payment Details" :
                  row.original.completed == 'YES' ? "Payment Details" : "Payment Details"
                : row.original.street_address != '' ? "ID Verification" : "Other"
          };
        });
  
        const csvOptions = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          useBom: true,
          useKeysAsHeaders: false,
          fileName: 'Abandoned Members',
          headers: ['Name','Email','Phone Number','PID','AID','Enrolled Date','Abandoned At']
        };
  
       // Convert data to CSV format
    const csvContent = convertToCSV(exportedData, csvOptions);
  
    // Create a Blob object from the CSV data
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  
    // Create a download link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = csvOptions.fileName + '.csv';
  
    // Append the link to the document body
    document.body.appendChild(link);
  
    // Programmatically click the link to trigger the file download
    link.click();
  
    // Clean up the temporary URL and remove the link from the document
    URL.revokeObjectURL(link.href);
    link.remove();
  };

    function ContentLayout() {
        return (
        <>
        <Grid container item lg={12} md={12} xs={12} sm={12} mt={2} mb={2}>
          <Typography color="primary" level="h4"> Abandoned Members</Typography>
        </Grid>
                <MaterialReactTable
                        columns={columns}
                        data={abandonedMembersData}
                        enableColumnFilterModes
                        filterFns={{
                          customSearchFilterFn: (row, id, filterValue) =>
                          row.getValue(id).toLowerCase().replace(/\s/g, '').includes(filterValue.toLowerCase().replace(/\s/g, '')),
                        }} 
                        globalFilterFn="customSearchFilterFn" //exact serach filter functionality
                        enablePinning
                        state={{ columnVisibility, rowSelection}} //pass our managed row selection state to the table to use
                        initialState={{
                          showColumnFilters: false,
                          density: 'compact',
                          columnPinning: { left: ['mrt-row-select','email'] }
                        }}
                        // onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                        positionToolbarAlertBanner="bottom"
                        enableDensityToggle={false}
                        renderTopToolbarCustomActions={({ table }) => (
                          <Box
                            sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                          >
                            <Button
                                color="primary"
                                disabled={table.getPrePaginationRowModel().rows.length === 0}
                                //export all rows, including from the next page, (still respects filtering and sorting)
                                  onClick={() =>
                                    handleExportData(table.getPrePaginationRowModel().rows)
                                  }
                                //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                startIcon={<FileDownloadIcon />}
                                variant="contained"
                              >
                                CSV
                              </Button>
                          </Box>
                        )}
                      />
        </>
              );
            }
            return (
              <div>
                <DefaultLayout content={<ContentLayout />} />
                <div>
                  <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                  >
                    <Freez />
                  </Backdrop>
                </div>
              </div>
            );
          }
          
          
export default AffiliateAbandoned;